var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_927_898",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_927_898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.29121 10.083C5.72796 10.083 5.24793 10.2983 4.85113 10.729C4.45495 11.1597 4.25686 11.6807 4.25686 12.292C4.25686 12.9307 4.45495 13.4653 4.85113 13.896C5.24793 14.3267 5.72796 14.542 6.29121 14.542C6.87965 14.542 7.37227 14.3267 7.76906 13.896C8.16586 13.4653 8.36426 12.9307 8.36426 12.292C8.36426 11.6807 8.16586 11.1597 7.76906 10.729C7.37227 10.2983 6.87965 10.083 6.29121 10.083ZM6.29121 27.125C5.72796 27.125 5.24793 27.3403 4.85113 27.771C4.45495 28.2017 4.25686 28.7363 4.25686 29.375C4.25686 29.9863 4.45495 30.5073 4.85113 30.938C5.24793 31.368 5.72796 31.583 6.29121 31.583C6.87965 31.583 7.37227 31.368 7.76906 30.938C8.16586 30.5073 8.36426 29.9863 8.36426 29.375C8.36426 28.7363 8.16586 28.2017 7.76906 27.771C7.37227 27.3403 6.87965 27.125 6.29121 27.125ZM1.10859 5.04199H25.9465C26.382 5.04199 26.7275 5.18066 26.983 5.45799C27.2391 5.73599 27.3672 6.11099 27.3672 6.58299V17.917C27.3672 18.389 27.2391 18.7917 26.983 19.125C26.7275 19.4583 26.382 19.625 25.9465 19.625H1.10859C0.698898 19.625 0.366289 19.4583 0.110767 19.125C-0.145369 18.7917 -0.273438 18.389 -0.273438 17.917V6.58299C-0.273438 6.11099 -0.145369 5.73599 0.110767 5.45799C0.366289 5.18066 0.698898 5.04199 1.10859 5.04199ZM2.29898 7.79199V16.833H24.7948V7.79199H2.29898ZM1.10859 22.042H25.87C26.2539 22.042 26.5994 22.2153 26.9065 22.562C27.2136 22.9093 27.3672 23.3053 27.3672 23.75V34.958C27.3672 35.486 27.2136 35.9027 26.9065 36.208C26.5994 36.514 26.2539 36.667 25.87 36.667H1.22376C0.814068 36.667 0.46211 36.514 0.167891 36.208C-0.126328 35.9027 -0.273438 35.486 -0.273438 34.958V23.75C-0.273438 23.3053 -0.145369 22.9093 0.110767 22.562C0.366289 22.2153 0.698898 22.042 1.10859 22.042ZM2.29898 24.833V33.875H24.7948V24.833H2.29898Z",
    fill: "#2B74E2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.e01ce74047bad2d0f89ccf4002a777a6.svg";
export { ForwardRef as ReactComponent };